<template>
  <!-- dialog add docs -->
  <custom-dialog
    :openDialog="isOpen"
    :widthDialog="'800px'"
    :classDialog="'createDialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('dialogClosed')"
  >
    <template #body>
      <h3 class="dialogTitle">Tìm kiếm văn bản liên quan</h3>
      <el-row :gutter="24" class="flex-row flex__left">
        <el-col :span="12" class="flex-row">
          <i class="el-icon-search margin-right-10 clickable"></i>
          <el-input
            size="medium"
            placeholder="Nhập Trích yếu/Số kí hiệu để tìm kiếm"
            class="style-fullWidth input-border__radius__0 input-border__bottom"
            v-model="keyword"
            @keydown.enter.exact.native="search"
          />
        </el-col>
        <el-col :span="12" class="flex-row">
          <el-radio
            v-model="objectType"
            :label="REFERENCE_OBJECT_TYPE.VB_INCOMING_DOC"
            @change="objectTypeChanged"
            >Văn bản đến
          </el-radio>
          <el-radio
            v-model="objectType"
            :label="REFERENCE_OBJECT_TYPE.VB_OUTGOING_DOC"
            @change="objectTypeChanged"
            >Văn bản đi
          </el-radio>
        </el-col>
      </el-row>

      <el-row :gutter="24" class="flex-row flex__left">
        <el-col :span="24" class="flex-row">
          <div class="margin-bottom-10 style-fullWidth">
            <el-table
              ref="multipleTable"
              :data="docs"
              size="mini"
              stripe
              style="width: 100%"
              max-height="500"
              @selection-change="selectionChanged"
            >
              <el-table-column type="selection" width="55"></el-table-column>

              <el-table-column
                label="Số kí hiệu"
                min-width="100px"
                property="docCode"
                show-overflow-tooltip
              >
              </el-table-column>

              <el-table-column
                property="docDate"
                label="Ngày văn bản"
                min-width="100px"
              >
                <template slot-scope="scope">
                  <i class="el-icon-time"></i>
                  <span>{{
                    scope.row.docDate
                      | dateFormatter({
                        dateFormat: "DD/MM/YYYY",
                        nullValue: "-"
                      })
                  }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="Trích yếu"
                property="quote"
                show-overflow-tooltip
                min-width="200px"
              >
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </template>
    <template #footer>
      <div class="flex-row form-button__action flex__right">
        <el-button
          size="medium"
          type="success"
          class="addDocs  color__white bg__blue btn-none__border"
          @click="save"
        >
          <i class="far fa-check-circle font-size__small"></i>
          &nbsp;Lưu
        </el-button>
        <el-button
          type="info"
          size="medium"
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
          >Bỏ qua
        </el-button>
      </div>
    </template>
  </custom-dialog>
</template>

<script>
import constants from "../../../constants";
import dateFormatter from "../../../filters/dateFormatter";
import vbIncomingDocService from "../../../services/vbIncomingDocService";
import CustomDialog from "../../common/custom-dialog";
import outgoingDocService from "../../../services/outgoingDocService";

export default {
  name: "hc-quychequydinh-add-docs-dialog",
  props: ["isOpen", "deptId"],
  filters: { dateFormatter },
  components: {
    CustomDialog
  },
  data() {
    return {
      keyword: null,
      docs: null,
      selectedDocs: null,
      objectType: null,
      REFERENCE_OBJECT_TYPE: constants.HC_DOC_RELATION.REFERENCE_OBJECT_TYPE
    };
  },

  created() {
    this.objectType =
      constants.HC_DOC_RELATION.REFERENCE_OBJECT_TYPE.VB_OUTGOING_DOC;
    this.search();
  },

  methods: {
    objectTypeChanged() {
      console.log("objectTypeChanged");
      this.selectedDocs = null;
      this.search();
    },

    itemClicked(item) {
      this.$refs.multipleTable.toggleRowSelection(item);
    },

    submit() {
      this.$emit("submit", { docs: this.selectedDocs, docType: this.docType });
    },

    cancel() {
      this.$emit("closeDialog");
    },

    selectionChanged(val) {
      this.selectedDocs = val;
    },

    save() {
      this.$emit("changed", {
        selectedDocs: this.selectedDocs,
        objectType: this.objectType
      });
    },

    search() {
      let pageable = { sort: "docDate,desc", page: 0, size: 100 };
      return (this.objectType ===
      constants.HC_DOC_RELATION.REFERENCE_OBJECT_TYPE.VB_OUTGOING_DOC
        ? outgoingDocService.findAllForHcCommandsDocRelation(
            this.deptId,
            this.keyword,
            pageable
          )
        : vbIncomingDocService.findAllForHcCommandsDocRelation(
            this.deptId,
            this.keyword,
            pageable
          )
      ).then(response => (this.docs = response.data));
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/quychequydinh/hc-quychequydinh-add-docs-dialog.vue